import { useParams, useNavigate } from 'react-router-dom'
import { ProjectLayout } from '@/components/layout/ProjectLayout'
import { useProject } from '@/hooks/useProjects'
import { Button } from '@/components/ui/button'
import { ProjectVfxTab } from '../ProjectVfxTab'

export function ProjectVfxPage() {
  const { id } = useParams<{ id: string }>()
  const navigate = useNavigate()
  const { data: project, isLoading, error } = useProject(id)

  if (isLoading) {
    return (
      <ProjectLayout>
        <div className="flex items-center justify-center py-12">
          <div className="text-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto mb-4"></div>
            <p className="text-muted-foreground">Loading project...</p>
          </div>
        </div>
      </ProjectLayout>
    )
  }

  if (error || !project) {
    return (
      <ProjectLayout>
        <div className="flex items-center justify-center py-12">
          <div className="text-center">
            <p className="text-destructive mb-4">Failed to load project</p>
            <Button onClick={() => navigate('/projects')}>Back to Projects</Button>
          </div>
        </div>
      </ProjectLayout>
    )
  }

  return (
    <ProjectLayout projectName={project.name}>
      <div className="space-y-6">
        <div>
          <h2 className="text-3xl font-bold tracking-tight">VFX Shots</h2>
          <p className="text-muted-foreground">
            Visual effects shots for {project.name}
          </p>
        </div>
        <ProjectVfxTab project={project} />
      </div>
    </ProjectLayout>
  )
}
